import { createSlice } from "@reduxjs/toolkit";

import {
  getAPILogDetails,
  getAPILogs,
  getBanksList,
  getGlobalSettings,
  getPageContentByType,
  getSettingsList,
  updateGlobalSettings,
  updateIntroPageDetails,
  updatePageContentByType,
} from "store/actions/globalSettingSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 100,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  globalSettings: {},
  pageContent: {},
  settingsList: [],
  banksList: [],
  apiLogs: [],
  apiLogsDetails: {},
  apiLogsFilterState: {
    pageNumber: 1,
    keyword: "",
    dates: [],
    selectedFilters: {
      status: -1,
      orderBy: -1,
      responseStatus: 0,
      url: "",
    },
  },
};

const globalSettingSlice = createSlice({
  name: "global setting",
  initialState,
  reducers: {
    updateApiLogsFilterState: (state, action) => {
      state.apiLogsFilterState = {
        ...state.apiLogsFilterState,
        ...action.payload,
      };
    },
    resetApiLogsFilterState: (state) => {
      state.apiLogsFilterState = initialState.apiLogsFilterState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGlobalSettings.pending, (state) => {
        state.loading = true;
        state.globalSettings = {};
      })
      .addCase(getGlobalSettings.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.globalSettings = data;
        }
      })
      .addCase(getGlobalSettings.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updateIntroPageDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateIntroPageDetails.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateIntroPageDetails.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getPageContentByType.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPageContentByType.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.pageContent = data;
        }
      })
      .addCase(getPageContentByType.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updatePageContentByType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePageContentByType.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updatePageContentByType.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateGlobalSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateGlobalSettings.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateGlobalSettings.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getSettingsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSettingsList.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.settingsList = data;
        }
      })
      .addCase(getSettingsList.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getBanksList.pending, (state) => {})
      .addCase(getBanksList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.banksList = data;
        }
      })
      .addCase(getBanksList.rejected, (state, action) => {});

    builder
      .addCase(getAPILogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAPILogs.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.apiLogs = data;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAPILogs.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getAPILogDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAPILogDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.apiLogsDetails = data || {};
        }
      })
      .addCase(getAPILogDetails.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default globalSettingSlice.reducer;

export const { updateApiLogsFilterState, resetApiLogsFilterState } =
  globalSettingSlice.actions;
